<template>
  <AppDialog
    :show="show"
    :title="title"
    size="large"
    append-to-body
    class="smart-notifications-dialog smart-notifications-templates-dialog"
    @close="emitClose"
  >
    <span class="description text-grey">{{ description }}</span>

    <div class="wrapper">
      <AppTable
        :table-data="templates"
        table-classes="mb-0"
        scrollable
        class="mb-0"
      >
        <AppTableColumn
          v-slot="{ row }"
          header=""
          cell-classes="template-thumbnail hide-sm"
          header-classes="column-header hide-sm"
        >
          <img :src="row.thumbnail_src" />
        </AppTableColumn>
        <AppTableColumn
          v-slot="{ row }"
          cell-classes="width-400"
          header="Name / Description"
          header-classes="column-header"
        >
          <div class="bold mb-8">{{ row.label }}</div>
          {{ row.description }}
        </AppTableColumn>
        <AppTableColumn
          v-slot="{ row }"
          cell-classes="width-400 hide-sm"
          header="Frequency"
          header-classes="column-header hide-sm"
        >
          {{ row.frequency }}
        </AppTableColumn>
        <AppTableColumn
          v-slot="{ row }"
          cell-classes="width-400 hide-sm"
          header="Delivered"
          header-classes="column-header hide-sm"
        >
          {{ row.trigger }}
        </AppTableColumn>
        <AppTableColumn
          v-slot="{ row }"
          cell-classes="template-button p-0"
          header=""
          header-classes="column-header"
        >
          <AppButton
            class="template-add"
            @click.stop="emitCreateNotification(row.key)"
          >
            <span>Add</span>
          </AppButton>
        </AppTableColumn>
      </AppTable>
    </div>
    <hr class="mt-0" />
    <div class="action-buttons">
      <AppButton @click.stop="emitClose">Close</AppButton>
    </div>
  </AppDialog>
</template>

<script>
import { SETTINGS_SMART_NOTIFICATIONS } from '~/app_constants';

export default {
  name: 'SmartNotificationsTemplatesDialog',
  props: {
    show: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    title() {
      return SETTINGS_SMART_NOTIFICATIONS.copy.template_dialog.title;
    },
    description() {
      return SETTINGS_SMART_NOTIFICATIONS.copy.template_dialog.description;
    },
    templates() {
      return Object.entries(SETTINGS_SMART_NOTIFICATIONS.templates).map(([key, value]) => ({ ...value, key }));
    },
  },
  methods: {
    emitClose() {
      this.$emit('close');
    },
    emitCreateNotification(key) {
      this.$emit('createNotificationWithTemplate', key);
    },
  },
};
</script>
